import '../modules/select';
import '../modules/range-slider';


// Filter show
$('.js-filter-open').on('click', function () {
  $('.filter').addClass('js-show');
  $('body').addClass('no-scroll');
  $('.elem-paranja').fadeIn();
});

// Filter hide
$('.js-filter-close, .elem-paranja').on('click', function () {
  $('.filter').removeClass('js-show');
  $('body').removeClass('no-scroll');
  $('.elem-paranja').fadeOut();
});

// Show all checkboxes
$('.js-show-all').on('click', function () {
  $(this).toggleClass('is-active');
  $(this).closest('.filter__group')
    .find('.filter__group-toggle').slideToggle();
});

// Popup sorting
$('.sorting__item').on('click', function () {
  $('.popup-sorting').slideToggle();
});